(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('FreightPaymentShipmentDialogController',FreightPaymentShipmentDialogController);

    FreightPaymentShipmentDialogController.$inject = ['$scope','entity','shipmentPage','shipmentId','$uibModalInstance','FreightPayment','ToastrService','MiscService','DateUtils'];

    function FreightPaymentShipmentDialogController($scope, entity, shipmentPage, shipmentId, $uibModalInstance, FreightPayment, ToastrService, MiscService, DateUtils) {
        var vm = this;

        vm.fp = entity;
        vm.shipmentPage = shipmentPage;
        vm.shipmentId = shipmentId;

        vm.clear = clear;
        vm.save = save;
        vm.updateInvoiceAmountDisplay = updateInvoiceAmountDisplay;
        vm.activateCurrencyType = activateCurrencyType;
        vm.onTextClick = onTextClick;
        vm.openCalendar = openCalendar;

        vm.isSaving = false;
        vm.currencyTypes = ['USD','EUR'];

        resolveDatesIfFreightPaymentNoId();

        vm.datePickerOpenStatus = {
            paymentDate: false
        };

        function openCalendar( date ) {
            vm.datePickerOpenStatus[date] = true;
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if(vm.shipmentId !== null) {
                vm.fp.shipment = {
                    id: vm.shipmentId
                };
            }
            if(vm.fp.id && vm.fp.id !== null && vm.fp.id > 0) {
                FreightPayment.update(vm.fp, onSaveSuccess, onSaveError);
            } else {
                if(vm.shipmentPage !== undefined && vm.shipmentPage) {
                    if(vm.shipmentId === null) {
                        onSaveSuccess(vm.fp);
                    } else {
                        FreightPayment.save(vm.fp, onSaveSuccess, onSaveError);
                    }
                } else {
                    FreightPayment.save(vm.fp, onSaveSuccess, onSaveError);
                }
            }
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $scope.$emit('ccsTrApp:freightPaymentUpdate', result);
            resolveDates();
            if(vm.shipmentId !== null) {
                ToastrService.success("Successfully saved Freight Payment", "Success!");
            }
            $uibModalInstance.close(result);
        }

        function onSaveError() {
            vm.isSaving = false;
            resolveDates();
            ToastrService.error("Something went wrong when saving Freight Payment", "Error");
        }

        function updateInvoiceAmountDisplay() {
            vm.fp.invoiceAmountDisplay = vm.fp.invoiceCurrency + " " + vm.fp.invoiceAmount;
        }

        function activateCurrencyType(option) {
            vm.fp.invoiceCurrency = option;
            updateInvoiceAmountDisplay();
        }

        function onTextClick($event) {
            $event.target.select();
        }

        function resolveDates() {
            if(vm.fp.paymentDate !== null) {
                // vm.fp.paymentDate = DateUtils.convertLocalDateFromServer(vm.fp.paymentDate);
                vm.fp.paymentDate = MiscService.dateFix(vm.fp.paymentDate);
            }
        }

        function resolveDatesIfFreightPaymentNoId() {
            if(vm.fp.id === null) {
                resolveDates();
            }
        }
    }
})();
